<div id="progress-bar-container">
    <div class="progress-bar-child progress"></div>
    <div class="progress-bar-child shrinker" [ngClass]="progressClass"></div>
</div>
